window.AwesomeBible = {
    BASE_URL: 'https://awesome.bible',
};

window.isMobileDevice = () => {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

//const Widgets = require('./jsx/widgets');
//const FeatureCarousel = require('./jsx/feature_carousel');

window.copyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};

window.resizeIframe = (obj) => {
    // https://stackoverflow.com/a/9976309/865091
    obj.style.height =
        obj.contentWindow.document.documentElement.scrollHeight + 'px';
};

$(function () {
    const CSS_CLASS_DISPLAYED = 'displayed';
    const HEADER_HEIGHT = 90;

    const mobileMenu = $('#mobile_menu');
    const header = $('#header');

    // state variables
    let headerIsVisible = true;
    let prevScrollTop = $(window).scrollTop();

    function handleMobileMenuButtonPressed(e) {
        toggleMobileMenu();
    }

    function toggleMobileMenu() {
        if (isMobileMenuDisplayed()) {
            hideMobileMenu();
        } else {
            showMobileMenu();
        }
    }

    function isMobileMenuDisplayed() {
        const displayed = mobileMenu.hasClass(CSS_CLASS_DISPLAYED);
        return displayed;
    }

    function handleMainPressed(e) {
        let result = undefined;
        if (isMobileMenuDisplayed()) {
            hideMobileMenu();
            e.preventDefault();
            result = false;
        } else {
            // do nothing
        }
        return result;
    }

    function showMobileMenu() {
        mobileMenu.addClass(CSS_CLASS_DISPLAYED);
    }

    function hideMobileMenu() {
        mobileMenu.removeClass(CSS_CLASS_DISPLAYED);
    }

    function initFeatureCarousel() {
        const domElement = document.getElementById('maskil_feature_carousel');
        if (domElement) {
            const featureCarousel = <FeatureCarousel />;
            ReactDOM.render(featureCarousel, domElement);
        }
    }

    function hideHeader() {
        if (headerIsVisible) {
            header.css('top', -HEADER_HEIGHT);
            headerIsVisible = false;
        }
    }

    function showHeader() {
        if (!headerIsVisible) {
            header.css('top', 0);
            headerIsVisible = true;
        }
    }

    function handleScroll() {
        // hide menu when scrolling down, and show when scrolling up
        const currentScrollTop = $(window).scrollTop();
        if (currentScrollTop < prevScrollTop) {
            // scrolling upward
            showHeader();
        } else {
            // scrolling downward
            hideHeader();
        }
        prevScrollTop = currentScrollTop;
    }

    // App Initializers
    function initEventHandlers() {
        $('#header .mobile-menu-button').click(handleMobileMenuButtonPressed);
        $('#mobile_menu .menu-button-close').click(hideMobileMenu);
        $('#main').click(handleMainPressed);
        $('#mobile_menu .mobile-menu-links a.close-immediately').click(
            hideMobileMenu
        );
        $(window).scroll($.throttle(250, handleScroll));
    }

    function init() {
        const widgets = <Widgets />;
        ReactDOM.render(widgets, document.getElementById('maskil_widgets'));

        initFeatureCarousel();
    }
    initEventHandlers();
    init();
});
